import React, { useEffect, useState, useRef } from 'react'
import Nlayout from './Nlayout'
import { Alert, Box, Button, CircularProgress, Grid, Link, Paper, Step, StepLabel, Stepper, TextField, Typography, styled } from '@mui/material'
import { Dialog } from "@mui/material";
import { FaCloudUploadAlt } from "react-icons/fa";
import { getEnhancedFingerprintWithMeta, getDeviceMetadata } from './fingerprint';
import { checkIpVpnStatus } from './services/vpnService';


import backgroundImg from './main_intro.jpg'
import axios from 'axios'
import TelegramVerificationCard from './components/TelegramVerificationCard';
import TelegramVerificationModal from './components/TelegramVerificationModal';
import { fetchTelegramStatus, getLocalTelegramData } from './services/telegramService';
import XbetVerificationCard from './components/XbetVerificationCard';
import { getXbetId } from './services/xbetService';

import paso1 from './img/paso1bonus.jpeg'

import paso1xbet from './img/paso1xbet.jpeg'
import paso2xbet from './img/paso2xbet.jpeg'
import paso3xbeta from './img/paso3beta.jpeg'
import paso3xbetb from './img/paso3betb.jpeg'
import paso4xbeta from './img/paso4xbeta.jpeg'
import paso4xbetb from './img/paso4xbetb.jpeg'
import paso5xbeta from './img/paso5xbeta.jpeg'
import paso5xbetb from './img/paso5xbetb.jpeg'
import paso5xbetc from './img/paso5xbetc.jpeg'
import paso6xbeta from './img/paso6xbeta.jpeg'
import paso6xbetb from './img/paso6xbetb.jpeg'
import paso7xbeta from './img/paso7xbeta.jpeg'
import paso7xbetb from './img/paso7xbetb.jpeg'
import paso11nuevo from './img/paso11nuevo.jpeg'
import tipeoextra from './img/TIPEOEXTA.png'
import paso2nuevoxbet from './img/paso2nuevoxbet.jpeg'
import paso3nuevo from './img/paso3nuevoxber.jpeg'
import paso111x from './img/paso111x.jpeg'
import paso2 from './Paso2-gif.gif'
import paso3 from './Paso3-gif.gif'
import vault from './vault.jpg'
import ej2 from './ejpaso2.jpg'
import ej3 from './ejpaso3.jpg'
import successImg from './withdraw.jpg'

import paso1bono from './img/paso1.jpeg'
import paso2bono from './img/paso2.jpeg'
import paso3bono from './img/paso3.jpeg'
import paso4bono from './img/paso4.jpeg'
import paso5bono from './img/paso5.jpeg'
import { BrowserQRCodeReader } from '@zxing/browser'

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const StepWrapper = ({ images, instruction, children }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5, height: '100%', justifyContent: 'space-between' }}>
            {images && (
                <Box
                    sx={{
                        flex: '0 0 230px',
                        height: '230px',
                        background: 'linear-gradient(135deg, #060e1f 0%, #0a1628 100%)',
                        borderRadius: '12px',
                        border: '1px solid #1a3260',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p: 1.5,
                        width: '80%',
                        margin: '0 auto',
                        position: 'relative',
                        boxShadow: 'inset 0 0 25px rgba(0,0,0,0.8), 0 4px 12px rgba(0,0,0,0.5)',
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            top: 0, right: 0, bottom: 0, left: 0,
                            background: 'radial-gradient(circle, transparent 40%, rgba(0,0,0,0.4) 100%)',
                            pointerEvents: 'none',
                        },
                        '& img': {
                            height: '100%',
                            width: 'auto',
                            maxHeight: '100%',
                            maxWidth: '100%',
                            objectFit: 'contain',
                            borderRadius: '8px',
                        }
                    }}
                >
                    {images}
                </Box>
            )}
            <Box
                sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    gap: 2,
                }}
            >
                {instruction && (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: 2,
                            backgroundColor: 'rgba(59, 130, 246, 0.08)',
                            p: 2,
                            borderRadius: '10px',
                            border: '1px solid rgba(59, 130, 246, 0.12)',
                            borderLeftWidth: '4px',
                            borderLeftColor: '#3b82f6',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                        }}
                    >
                        <Box
                            sx={{
                                width: '28px',
                                height: '28px',
                                borderRadius: '50%',
                                backgroundColor: '#1d4ed8',
                                color: '#fff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                                fontWeight: 'bold',
                                fontSize: '0.9rem',
                            }}
                        >
                            i
                        </Box>
                        <Box sx={{ flex: 1 }}>{instruction}</Box>
                    </Box>
                )}
                {children}
            </Box>
        </Box>
    );
};



function Bonos(props) {
    const [userEmail, setUserEmail] = useState('');
    const mailKick = localStorage.getItem('kick_mail')
    const [solicitudes, setSolicitudes] = useState()
    const [solicitudesBono2da, setSolicitudesBono2da] = useState()
    const [cargar, setCargar] = useState()
    const nombre = localStorage.getItem('kick_user')
    const [isWinner, setIsWinner] = useState()
    const [xbetId, setXbetId] = useState(null);
    // Estados para el modal
    const [showWarningModal, setShowWarningModal] = useState(false);
    const [triggerUpload, setTriggerUpload] = useState(null);
    const checkWinner = async () => {
        setCargar(true)
        const peticion = await axios.post(`https://backend.eldenguee.com/sorteo/check-ganador`, { nombre })
        const peticionTipeo = await axios.post(`https://backend.eldenguee.com/solicitudes/tipeo`, { nombre })
        const soli = peticionTipeo?.data?.map((p) => p.bonos)
        const Bono2da = peticionTipeo?.data?.map((p) => p.Bono2da)
        setSolicitudes(soli)
        setSolicitudesBono2da(Bono2da)
        setIsWinner(peticion?.data)
        setUserEmail(mailKick)

        try {
            const userRes = await axios.post('https://backend.eldenguee.com/solicitudes/usuario', { nombre });
            if (userRes?.data?.[0]?.xbet_id) {
                setXbetId(String(userRes.data[0].xbet_id).trim());
            }
        } catch (_) {}

        setTimeout(() => {
            setCargar(false)

        }, 3000);
        setCargar(false)

    }
    const getSafeLocalStorage = (key) => {
        try {
            return localStorage.getItem(key);
        } catch (e) {
            console.warn("localStorage is not accessible:", e);
            return null;
        }
    };

    const setSafeLocalStorage = (key, value) => {
        try {
            localStorage.setItem(key, value);
        } catch (e) {
            console.warn("localStorage set failed:", e);
        }
    };

    useEffect(() => { checkWinner() }, [])

    const [activeStep, setActiveStep] = useState(0);
    const [offerScreenshot, setOfferScreenshot] = useState(null);
    const [bnbScreenshot, setBnbScreenshot] = useState(null);
    const [bnbAddress, setBnbAddress] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const isSubmittingRef = useRef(false);
    const [success, setSuccess] = useState(false);
    const [offerScreenshotUrl, setOfferScreenshotUrl] = useState('');
    const [bnbScreenshotUrl, setBnbScreenshotUrl] = useState('');
    const [url, setUrl] = useState('')
    const steps = ['Paso 1', 'Paso 2', 'Paso 3', 'Paso 4', 'Paso 5', 'Paso 6', 'Paso 7', 'Paso 8', 'Paso 9', 'Paso 10', 'Paso 11'];


    const handleNext = () => {
        if (validateStep()) {
            setError('');
            setActiveStep((prev) => prev + 1);
        }
    };

    const handleBack = () => {
        setError('');
        setActiveStep((prev) => prev - 1);
    };

    const validateStep = () => {

        if (activeStep === 6 && (!bnbAddress)) {

            setError('Debes escribir la direccion BNB');
            return false;
        }
        if (activeStep === 3 && (!offerScreenshotUrl)) {
            setError('Debes subir la captura');
            return false;
        }

        return true;
    };

    const [deshabilitarBoton, setDeshabilitarBoton] = useState(false)
    const [fingerprint, setFingerprint] = useState('');
    const [webrtcLocalIps, setWebrtcLocalIps] = useState([]);
    const [vpnSuspected, setVpnSuspected] = useState(false);
    // Función para obtener el fingerprint mejorado
    const getFingerprint = async () => {
        try {
            const result = await getEnhancedFingerprintWithMeta();

            console.log('✅ Enhanced Fingerprint ID:', result.fingerprint);
            console.log('🌐 WebRTC local IPs:', result.webrtcLocalIps);
            console.log('🔴 VPN suspected:', result.vpnSuspected);

            setFingerprint(result.fingerprint);
            setWebrtcLocalIps(result.webrtcLocalIps);
            setVpnSuspected(result.vpnSuspected);

            // Guardamos también en localStorage como respaldo
            setSafeLocalStorage('userFingerprint_v2', result.fingerprint);

            return result.fingerprint;
        } catch (error) {
            console.error('❌ Error generando fingerprint:', error);
            return null;
        }
    };
    // Obtenemos el fingerprint al montar el componente
    useEffect(() => {
        getFingerprint();
    }, []);
    // Función auxiliar para obtener fingerprint (usa el estado o localStorage)
    const getOrCreateFingerprint = async () => {
        if (fingerprint) return fingerprint;

        const saved = getSafeLocalStorage('userFingerprint_v2');
        if (saved) {
            setFingerprint(saved);
            return saved;
        }

        return await getFingerprint();
    };
    // ==================== NUEVA FUNCIÓN DE SUBIDA (Proxy) ====================
    const uploadToServer = async (file) => {
        if (!file || !(file instanceof File)) {
            throw new Error('Archivo inválido');
        }

        const formData = new FormData();
        formData.append('imagen', file);   // ← Nombre del campo que espera tu backend

        const response = await fetch('https://backend.eldenguee.com/solicitudes/upload', {
            method: 'POST',
            body: formData,
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || 'Error al subir la imagen');
        }

        const data = await response.json();
        return data.url || data.fileUrl || data.filename; // Ajusta según lo que devuelva tu backend
    };
    const getPublicIP = async () => {
        const res = await fetch('https://api.ipify.org?format=json');
        const data = await res.json();
        return data.ip;
    };
    // Manejar cambio de archivo y subir a Cloudinary
    const handleFileChange = (setFile, setUrl) => async (event) => {
        const file = event.target.files[0];
        if (file) {
            setFile(file);
            try {
                setIsUploading(true);
                const url = await uploadToServer(file);
                setUrl(url);
                setError('');
            } catch (err) {
                setError('Error al subir la imagen: ' + err.message);
            } finally {
                setIsUploading(false);
            }
        }
    };
    const [telegramModalOpen, setTelegramModalOpen] = useState(false);
    const [tgStatus, setTgStatus] = useState(null);

    useEffect(() => {
        if (!nombre) return;
        const cached = getLocalTelegramData(nombre);
        if (cached) setTgStatus(cached);

        fetchTelegramStatus(nombre).then(data => {
            if (data) setTgStatus(data);
        }).catch(err => console.error('Error obteniendo estado Telegram:', err));
    }, [nombre]);

    const isTelegramVerified = Boolean(tgStatus?.verified || tgStatus?.isVerified);

    const handleRequestTipeo = async () => {
        if (isSubmittingRef.current || loading || deshabilitarBoton) return;
        isSubmittingRef.current = true;
        setDeshabilitarBoton(true);
        setLoading(true);
        setError('');

        const userKick = nombre || localStorage.getItem('kick_user');
        if (!userKick || userKick === 'null' || userKick === 'undefined') {
            setError('⚠️ Debes iniciar sesión con tu cuenta de Kick antes de enviar la solicitud.');
            setLoading(false);
            return;
        }

        // Verificar Telegram obligatoriamente antes de reclamar
        const tgStatus = await fetchTelegramStatus(userKick);
        if (!tgStatus || (!tgStatus.verified && !tgStatus.isVerified)) {
            setError('⚠️ Debes verificar tu cuenta de Telegram y número de celular antes de reclamar.');
            setTelegramModalOpen(true);
            setLoading(false);
            return;
        }

        // Verificar 1XBET ID obligatoriamente antes de reclamar
        if (!xbetId) {
            const xbetRes = await getXbetId(userKick);
            if (!xbetRes?.verified && !xbetRes?.xbet_id) {
                setError('⚠️ Debes registrar y confirmar tu 1XBET ID antes de enviar la solicitud.');
                setLoading(false);
                return;
            } else if (xbetRes?.xbet_id) {
                setXbetId(String(xbetRes.xbet_id).trim());
            }
        }

        const ip = await getPublicIP();

        const fp = await getOrCreateFingerprint();
        const deviceMeta = await getDeviceMetadata();
        try {
            if (!bnbAddress.startsWith('0x')) {
                throw new Error('UPS! eso no parece una dirección BNB');
            }

            if (activeStep === 2 && (
                bnbAddress?.toLowerCase() === '0x3f1bD53eB8A3F5d60147A5C0c47279a...' ||
                bnbAddress?.toLowerCase() === '0x3f1bD53eB8A3F5d60147A5C0c47279a'
            )) {
                setError('La dirección BNB debe ser una real..');
                return false;
            }

            setDeshabilitarBoton(true)
            const offerScreenshotUrl = await uploadToServer(offerScreenshot);

            // Consultar estado de seguridad/VPN del backend
            const secStatus = await checkIpVpnStatus();
            const isVpnFlag = secStatus.allowed === false || secStatus.isVpn || secStatus.isProxy || secStatus.isHosting || secStatus.isTor || vpnSuspected;

            // Enviar solicitud al backend proxy
            const response = await fetch('https://backend.eldenguee.com/solicitudes/submit-request-bonos', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    nombre: userKick,
                    bnbAddress,
                    offerScreenshot: offerScreenshotUrl,
                    fingerprint: fp,
                    ip: secStatus.ip || ip,
                    deviceMetadata: deviceMeta,
                    // Datos anti-VPN: IPs locales estables + flag de sospecha
                    webrtcLocalIps,
                    vpnSuspected: isVpnFlag,
                    vpnRiskScore: secStatus.vpnRiskScore || 0,
                    vpnReasons: secStatus.reasons || [],
                }),
            });


            console.log('response', response)
            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || 'Error al enviar la solicitud');
            }

            setSuccess(true);
        } catch (err) {
            setError('Error: ' + err.message);
        } finally {
            isSubmittingRef.current = false;
            setLoading(false);
            setDeshabilitarBoton(false);
        }
    };
    const [isUploading, setIsUploading] = useState(false);



    const [isOpen, setIsOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const openImage = (url) => {
        setSelectedImage(url);
        setIsOpen(true);
    };

    const closeImage = () => {
        setIsOpen(false);
        setSelectedImage(null);
    };

    const getStepContent = (step) => {
        const btnBack = (
            <Button
                disabled={activeStep === 0 || loading}
                onClick={handleBack}
                variant="outlined"
                sx={{
                    flex: 1,
                    textTransform: 'none',
                    fontWeight: 'bold',
                    py: 1,
                    borderColor: '#1a3260',
                    color: '#94a3b8',
                    '&:hover': { borderColor: '#3b82f6', color: '#3b82f6', backgroundColor: 'rgba(59,130,246,0.06)' },
                }}
            >
                ← Atrás
            </Button>
        );
        const btnNext = (
            <Button
                variant="contained"
                onClick={handleNext}
                sx={{
                    flex: 1,
                    textTransform: 'none',
                    fontWeight: 'bold',
                    py: 1,
                    backgroundColor: '#3b82f6',
                    '&:hover': { backgroundColor: '#2563eb' },
                    boxShadow: '0 0 10px rgba(59,130,246,0.4)',
                }}
            >
                Siguiente →
            </Button>
        );
        const btnFinish = (
            <Button
                variant="contained"
                onClick={handleRequestTipeo}
                disabled={deshabilitarBoton}
                sx={{
                    flex: 1,
                    textTransform: 'none',
                    fontWeight: 'bold',
                    py: 1,
                    backgroundColor: '#3b82f6',
                    '&:hover': { backgroundColor: '#2563eb' },
                    '&:disabled': { backgroundColor: '#1a2f5a', color: '#60a5fa' },
                    boxShadow: '0 0 10px rgba(59,130,246,0.4)',
                }}
            >
                {deshabilitarBoton ? 'Enviando...' : 'Terminar →'}
            </Button>
        );

        switch (step) {
            case 0:
                return (
                    <StepWrapper
                        images={<img src={paso1xbet} alt="Paso 1" onClick={() => openImage(paso1xbet)} style={{ cursor: 'pointer' }} />}
                        instruction={
                            <Box sx={{ color: '#cbd5e1', fontSize: '0.95rem', lineHeight: '1.5' }}>
                                <Typography paragraph sx={{ mb: 1.5 }}>
                                    Para comenzar, registrate en 1XBET desde el enlace remarcado al final y utilizá el código promocional <strong style={{ color: '#ef4444' }}>eldenguee</strong>. Es un requisito indispensable para poder reclamar el tipeo, <span style={{ fontStyle: 'italic', fontSize: '0.85rem' }}>además podés completar el registro de forma rápida y sencilla con la opción de registro en 1 clic.</span>
                                </Typography>
                                <Typography paragraph sx={{ mb: 1.5 }}>
                                    Si ya tenés una cuenta creada con el código promocional <strong style={{ color: '#ef4444' }}>eldenguee</strong>, podés utilizar esa misma sin necesidad de crear una nueva. <span style={{ fontStyle: 'italic', fontSize: '0.85rem' }}>Si tu cuenta fue registrada con otro código o sin código, no será válida para reclamar el beneficio y se rechazará tu solicitud </span><strong>(no hay reintegro de solicitud)</strong>.
                                </Typography>
                                <Link href="https://bit.ly/4wIcqjh" target="_blank" rel="noopener noreferrer" sx={{ color: '#60a5fa', fontWeight: 'bold', display: 'inline-block', mt: 0.5 }}>
                                    https://bit.ly/4wIcqjh
                                </Link>
                            </Box>
                        }
                    >
                        <Box sx={{ display: 'flex', gap: 2 }}>{btnBack}{btnNext}</Box>
                    </StepWrapper>
                );
            case 1:
                return (
                    <StepWrapper
                        images={<img src={paso2xbet} alt="Paso 2" onClick={() => openImage(paso2xbet)} style={{ cursor: 'pointer' }} />}
                        instruction={
                            <Box sx={{ color: '#cbd5e1', fontSize: '0.95rem', lineHeight: '1.5' }}>
                                <Typography paragraph sx={{ mb: 1.5 }}>
                                    Una vez completado el registro, la plataforma te mostrará los datos de acceso de tu cuenta. <strong>Te recomendamos guardarlos en un lugar seguro para no olvidarlos y poder ingresar fácilmente en el futuro (los necesitaras).</strong>
                                </Typography>
                                <Typography paragraph sx={{ mb: 0, fontStyle: 'italic' }}>
                                    Si ya tenés una cuenta creada previamente con el código eldenguee, podés saltear este paso y continuar con el siguiente.
                                </Typography>
                            </Box>
                        }
                    >
                        <Box sx={{ display: 'flex', gap: 2 }}>{btnBack}{btnNext}</Box>
                    </StepWrapper>
                );
            case 2:
                return (
                    <StepWrapper
                        images={<img src={paso2nuevoxbet} alt="Paso 3" onClick={() => openImage(paso2nuevoxbet)} style={{ cursor: 'pointer' }} />}
                        instruction={
                            <Typography sx={{ fontSize: '0.95rem', lineHeight: '1.5', color: '#cbd5e1' }}>
                                Ingresá a tu perfil seleccionando el ícono ubicado en la parte superior derecha de la pantalla. Luego, dirigite a la sección <strong style={{ color: '#facc15' }}>&quot;Datos Personales&quot;</strong> para continuar con el proceso, tal como se muestra en la imagen.
                            </Typography>
                        }
                    >
                        <Box sx={{ display: 'flex', gap: 2 }}>{btnBack}{btnNext}</Box>
                    </StepWrapper>
                );
            case 3:
                return (
                    <StepWrapper
                        images={<img src={paso3nuevo} alt="Paso 4" onClick={() => openImage(paso3nuevo)} style={{ cursor: 'pointer' }} />}
                        instruction={
                            <Typography sx={{ fontSize: '0.95rem', lineHeight: '1.5', color: '#cbd5e1' }}>
                                Realizá una captura de pantalla de la información que aparece dentro de la sección &quot;Datos Personales&quot; y subila como comprobante, <strong>tal como se muestra en la imagen de ejemplo.</strong>
                            </Typography>
                        }
                    >
                        <Box
                            sx={{
                                backgroundColor: 'rgba(239, 68, 68, 0.1)',
                                borderRadius: 2,
                                p: 1.5,
                                color: '#fca5a5',
                                border: '1px dashed #ef4444',
                                mb: 1.5,
                            }}
                        >
                            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                Importante: La imagen debe ser tomada el mismo día en que se realiza la solicitud y debe enviarse completa, sin recortes ni modificaciones. En caso de no cumplir con estos requisitos, la solicitud será rechazada por el sistema.
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                backgroundColor: 'rgba(59, 130, 246, 0.06)',
                                borderRadius: 2,
                                p: 1.5,
                                color: '#cbd5e1',
                                border: '1px dashed #1e3a6e',
                            }}
                        >
                            <Box sx={{ borderBottom: '1px solid #1e3a6e', display: 'flex', justifyContent: 'space-between', pb: 1, mb: 1 }}>
                                <Typography variant="body2">Tu imagen</Typography>
                                <Typography variant="body2" sx={{ color: '#94a3b8' }}>
                                    {offerScreenshot ? `Archivo: ${offerScreenshot.name}` : 'No hay archivo'}
                                </Typography>
                            </Box>
                            {isUploading ? (
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60px' }}>
                                    <CircularProgress size={24} color="inherit" />
                                </Box>
                            ) : (
                                offerScreenshotUrl && (
                                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                                        <img src={offerScreenshotUrl} style={{ maxHeight: '60px', maxWidth: '100%', borderRadius: '4px', cursor: 'pointer' }} alt="Preview" onClick={() => openImage(offerScreenshotUrl)} />
                                    </Box>
                                )
                            )}
                        </Box>
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <Button
                                component="label"
                                variant="contained"
                                startIcon={<FaCloudUploadAlt />}
                                sx={{
                                    backgroundColor: '#1e3a6e',
                                    color: '#fff',
                                    flex: 1,
                                    textTransform: 'none',
                                    fontWeight: 'bold',
                                    py: 1,
                                    '&:hover': { backgroundColor: '#2d5aa0' },
                                }}
                                onClick={() => {
                                    setTriggerUpload(() => () =>
                                        document.getElementById('bnbScreenshotInput').click()
                                    );
                                    setShowWarningModal(true);
                                }}
                            >
                                Cargar imagen
                            </Button>
                            <VisuallyHiddenInput
                                id="bnbScreenshotInput"
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange(setOfferScreenshot, setOfferScreenshotUrl)}
                            />
                            {btnBack}
                            {btnNext}
                        </Box>
                    </StepWrapper>
                );
            case 4:
                return (
                    <StepWrapper
                        images={<img src={paso3xbeta} alt="Paso 5" onClick={() => openImage(paso3xbeta)} style={{ cursor: 'pointer' }} />}
                        instruction={
                            <Typography sx={{ fontSize: '0.95rem', lineHeight: '1.5', color: '#cbd5e1' }}>
                                Para recibir el dinero, necesitás tener instalada la billetera virtual <span style={{ color: '#00e676', fontWeight: 'bold' }}>LEMON</span>. Si todavía no la tenés, <strong>descargala y verifica tu cuenta</strong>. En caso de que ya la tengas instalada, simplemente seleccioná &quot;Siguiente&quot; para continuar con el proceso.
                            </Typography>
                        }
                    >
                        <Box sx={{ display: 'flex', gap: 2 }}>{btnBack}{btnNext}</Box>
                    </StepWrapper>
                );
            case 5:
                return (
                    <StepWrapper
                        images={
                            <Box sx={{ display: 'flex', gap: 1, height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                                <img src={paso4xbeta} alt="Paso 6a" onClick={() => openImage(paso4xbeta)} style={{ maxHeight: '100%', maxWidth: '48%', objectFit: 'contain', cursor: 'pointer' }} />
                                <img src={paso4xbetb} alt="Paso 6b" onClick={() => openImage(paso4xbetb)} style={{ maxHeight: '100%', maxWidth: '48%', objectFit: 'contain', cursor: 'pointer' }} />
                            </Box>
                        }
                        instruction={
                            <Typography sx={{ fontSize: '0.95rem', lineHeight: '1.5', color: '#cbd5e1' }}>
                                Una vez dentro de <span style={{ color: '#00e676', fontWeight: 'bold' }}>LEMON</span>, ingresá a la sección <span style={{ color: '#ef4444', fontWeight: 'bold' }}>&quot;Depositar&quot;</span> y seleccioná la opción <span style={{ color: '#ef4444', fontWeight: 'bold' }}>&quot;Crypto&quot;</span> para continuar con el proceso.
                            </Typography>
                        }
                    >
                        <Box sx={{ display: 'flex', gap: 2 }}>{btnBack}{btnNext}</Box>
                    </StepWrapper>
                );
            case 6:
                return (
                    <StepWrapper
                        images={
                            <Box sx={{ display: 'flex', gap: 1, height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                                <img src={paso5xbeta} alt="6a" onClick={() => openImage(paso5xbeta)} style={{ maxHeight: '100%', maxWidth: '30%', objectFit: 'contain', cursor: 'pointer' }} />
                                <img src={paso5xbetb} alt="6b" onClick={() => openImage(paso5xbetb)} style={{ maxHeight: '100%', maxWidth: '38%', objectFit: 'contain', cursor: 'pointer' }} />
                                <img src={paso5xbetc} alt="6c" onClick={() => openImage(paso5xbetc)} style={{ maxHeight: '100%', maxWidth: '30%', objectFit: 'contain', cursor: 'pointer' }} />
                            </Box>
                        }
                        instruction={
                            <Typography sx={{ fontSize: '0.95rem', lineHeight: '1.5', color: '#cbd5e1' }}>
                                Buscá la criptomoneda <strong style={{ color: '#facc15' }}>BNB</strong> y seleccionála. Luego, elegí la red <strong>BNB Chain (BEP-20)</strong>. Finalmente, copiá y pegá en el campo que figura abajo la dirección de depósito que te proporciona la aplicación <span style={{ color: '#00e676', fontWeight: 'bold' }}>LEMON</span>. <span style={{ fontStyle: 'italic', fontSize: '0.85rem' }}>(Recomendamos apretar el icono de copiar en la aplicacion de Lemon para evitar problemas, recuerda que si la copias mal no te llegara el dinero)</span>
                            </Typography>
                        }
                    >
                        <TextField
                            fullWidth
                            value={bnbAddress}
                            onChange={(e) => setBnbAddress(e.target.value)}
                            variant="outlined"
                            placeholder='0x...'
                            sx={{
                                backgroundColor: '#06102a',
                                borderRadius: '8px',
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': { borderColor: '#1a3260' },
                                    '&:hover fieldset': { borderColor: '#3b82f6' },
                                    '&.Mui-focused fieldset': { borderColor: '#60a5fa' },
                                    input: { color: 'white', height: '44px', boxSizing: 'border-box' },
                                },
                            }}
                        />
                        <Box sx={{ display: 'flex', gap: 2 }}>{btnBack}{btnNext}</Box>
                    </StepWrapper>
                );
            case 7:
                return (
                    <StepWrapper
                        images={<img src={paso6xbeta} alt="Paso 8" onClick={() => openImage(paso6xbeta)} style={{ cursor: 'pointer' }} />}
                        instruction={
                            <Box sx={{ color: '#cbd5e1', fontSize: '0.95rem', lineHeight: '1.5' }}>
                                <Typography paragraph sx={{ mb: 1.5 }}>
                                    Una vez finalizada la solicitud de tipeo y <strong>cuando eldenguee haya coordinado el horario de entrega de la primera tanda</strong>, recibirás un correo electrónico confirmando el depósito en tu cuenta de <span style={{ color: '#00e676', fontWeight: 'bold' }}>LEMON</span>.
                                </Typography>
                                <Typography paragraph sx={{ mb: 0 }}>
                                    Podés verificar que el saldo fue acreditado ingresando a la sección &quot;Portfolio&quot; dentro de la aplicación. <span style={{ fontStyle: 'italic', fontSize: '0.85rem' }}>Seleccioná &quot;Siguiente&quot; para avanzar con tu solicitud.</span>
                                </Typography>
                            </Box>
                        }
                    >
                        <Box sx={{ display: 'flex', gap: 2 }}>{btnBack}{btnNext}</Box>
                    </StepWrapper>
                );
            case 8:
                return (
                    <StepWrapper
                        images={
                            <Box sx={{ display: 'flex', gap: 1, height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                                <img src={paso6xbetb} alt="8a" onClick={() => openImage(paso6xbetb)} style={{ maxHeight: '100%', maxWidth: '33%', objectFit: 'contain', cursor: 'pointer' }} />
                                <img src={paso7xbeta} alt="8b" onClick={() => openImage(paso7xbeta)} style={{ maxHeight: '100%', maxWidth: '33%', objectFit: 'contain', cursor: 'pointer' }} />
                                <img src={paso7xbetb} alt="8c" onClick={() => openImage(paso7xbetb)} style={{ maxHeight: '100%', maxWidth: '33%', objectFit: 'contain', cursor: 'pointer' }} />
                            </Box>
                        }
                        instruction={
                            <Box sx={{ color: '#cbd5e1', fontSize: '0.95rem', lineHeight: '1.5' }}>
                                <Typography paragraph sx={{ mb: 1.5 }}>
                                    Una vez acreditado el saldo en tu cuenta de <span style={{ color: '#00e676', fontWeight: 'bold' }}>LEMON</span>, ingresá a la sección <span style={{ color: '#ef4444', fontWeight: 'bold' }}>&quot;Inicio&quot;</span> y seleccioná la opción <span style={{ color: '#ef4444', fontWeight: 'bold' }}>&quot;Usar&quot;</span>.
                                </Typography>
                                <Typography paragraph sx={{ mb: 1.5 }}>
                                    Luego, elegí <span style={{ color: '#ef4444', fontWeight: 'bold' }}>&quot;Vender Crypto&quot;</span>, seleccioná la moneda <strong>BNB o SOL</strong> <span style={{ fontStyle: 'italic', fontSize: '0.85rem' }}>(depende la que haya llegado)</span> e ingresá el monto máximo disponible. <span style={{ fontStyle: 'italic' }}>Para hacerlo más rápido, podés presionar la opción &quot;Max&quot; y el monto se completará automáticamente.</span>
                                </Typography>
                                <Typography paragraph sx={{ mb: 0 }}>
                                    A continuación, seleccioná <span style={{ color: '#ef4444', fontWeight: 'bold' }}>&quot;Peso Argentino&quot;</span>, continuá con la operación y confirmá la venta para finalizar el proceso.
                                </Typography>
                            </Box>
                        }
                    >
                        <Box sx={{ display: 'flex', gap: 2 }}>{btnBack}{btnNext}</Box>
                    </StepWrapper>
                );
            case 9:
                return (
                    <StepWrapper
                        images={<img src={paso1} alt="Paso 10" onClick={() => openImage(paso1)} style={{ cursor: 'pointer' }} />}
                        instruction={
                            <Box sx={{ color: '#cbd5e1', fontSize: '0.95rem', lineHeight: '1.5' }}>
                                <Typography paragraph sx={{ mb: 1.5 }}>
                                    Realizá un depósito en <span style={{ color: '#38bdf8', fontWeight: 'bold' }}>1XBET</span> por el <strong>monto total del tipeo</strong> utilizando cualquiera de los métodos disponibles para ingresar pesos argentinos, como transferencia bancaria, <span style={{ color: '#00e676', fontWeight: 'bold' }}>LEMON</span> u otras opciones habilitadas en la plataforma.
                                </Typography>
                                <Box
                                    sx={{
                                        backgroundColor: 'rgba(239, 68, 68, 0.1)',
                                        borderRadius: 2,
                                        p: 1.5,
                                        color: '#fca5a5',
                                        border: '1px dashed #ef4444',
                                    }}
                                >
                                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                        Es importante que el deposito sea realizado por la TOTALIDAD del monto del tipeo, de lo contrario entrarias en la Blacklist!
                                    </Typography>
                                </Box>
                            </Box>
                        }
                    >
                        <Box sx={{ display: 'flex', gap: 2 }}>{btnBack}{btnNext}</Box>
                    </StepWrapper>
                );
            case 10:
                return (
                    <StepWrapper
                        images={<img src={paso11nuevo} alt="Paso 11" onClick={() => openImage(paso11nuevo)} style={{ cursor: 'pointer' }} />}
                        instruction={
                            <Box sx={{ color: '#cbd5e1', fontSize: '0.95rem', lineHeight: '1.5' }}>
                                <Typography paragraph sx={{ mb: 1.5 }}>
                                    Recordá <strong>realizar una captura de pantalla del depósito efectuado en tu cuenta de <span style={{ color: '#38bdf8', fontWeight: 'bold' }}>1XBET</span></strong>.
                                </Typography>
                                <Box
                                    sx={{
                                        backgroundColor: 'rgba(239, 68, 68, 0.1)',
                                        borderRadius: 2,
                                        p: 1.5,
                                        color: '#fca5a5',
                                        border: '1px dashed #ef4444',
                                    }}
                                >
                                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                                        Tené en cuenta que contas con un plazo máximo de 18 horas para verificar que realizaste el deposito en tu cuenta de 1xbet, en caso de lo contrario automaticamente tu cuenta será incorporada a la blacklist y quedarás vetado para ganar futuros sorteos y reclamar tipeos.
                                    </Typography>
                                </Box>
                            </Box>
                        }
                    >
                        <Box sx={{ display: 'flex', gap: 2 }}>{btnBack}{btnFinish}</Box>
                    </StepWrapper>
                );
            default:
                return null;
        }
    };


    const redirectHome = () => {
        window.location.href = '/'
    }
    return (
        <Nlayout>
            <Grid style={{ background: '#11111d', width: '100%' }}>

                {
                    cargar ?
                        <Grid className='mt-bg-fondo' style={{
                            height: '980px',
                            backgroundColor: '#3f3d45',
                            margin: '0 auto',
                            position: 'relative',
                            backgroundPosition: '50%'
                        }}>
                            <Grid className='container' style={{
                                padding: 50,
                                gap: '10px',
                                justifyContent: 'center',
                                overflow: 'scroll !important'

                            }}>
                                <Grid style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 15 }}>
                                    <Typography style={{ color: 'white', fontWeight: 'bold', fontSize: '32px', fontFamily: 'Outfit,sans-serif' }} >
                                        eldenguee.com
                                    </Typography>
                                    <Typography sx={{
                                        background: 'linear-gradient(317deg,#b58a1b 4.52%,#e0c060 34.37%,#ffeeb2 50.47%,#ffe77c 65.63%,#ffca41 110.56%)',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',
                                        fontWeight: 'bold',
                                        fontSize: props.isMobile ? 32 : 65,
                                        fontFamily: 'Belerofonte'
                                    }} >Verificando..</Typography>
                                </Grid>

                                <Grid style={{ display: 'flex', alignItems: 'center', gap: '10px' }} >

                                </Grid>
                            </Grid>
                        </Grid>

                        :

                        (solicitudes < 1 || solicitudesBono2da >= 1) ?

                            <Grid className='mt-bg-fondo' style={{

                                height: '980px',
                                backgroundColor: '#3f3d45',
                                margin: '0 auto',
                                position: 'relative',
                                backgroundPosition: '50%'
                            }}>
                                <Grid className='container' style={{
                                    padding: 50,
                                    gap: '10px',
                                    justifyContent: 'center',
                                    overflow: 'scroll !important'


                                }}>
                                    <Grid style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 15 }}>
                                        <Typography style={{ color: 'white', fontWeight: 'bold', fontSize: '32px', fontFamily: 'Outfit,sans-serif', textAlign: 'center' }} >
                                            {solicitudesBono2da >= 1 ? 'Todavia tenes un tipeo extra por reclamar, no podés solicitar más tipeos hasta reclamar el otro.' : 'No estás habilitado para solicitar tipeo, lo tienes que ganar en algún sorteo realizado por el dengue!'}

                                        </Typography>
                                        <Typography sx={{
                                            background: 'linear-gradient(317deg,#b58a1b 4.52%,#e0c060 34.37%,#ffeeb2 50.47%,#ffe77c 65.63%,#ffca41 110.56%)',
                                            WebkitBackgroundClip: 'text',
                                            WebkitTextFillColor: 'transparent',
                                            fontWeight: 'bold',
                                            fontSize: props.isMobile ? 32 : 50,
                                            fontFamily: 'Belerofonte'
                                        }} >Eldenguee.com</Typography>
                                    </Grid>

                                    <Grid style={{ display: 'flex', alignItems: 'center', gap: '10px' }} >


                                        <Button

                                            sx={{
                                                color: 'black',
                                                fontWeight: 'bold',
                                                padding: '0.75rem 2rem',
                                                fontSize: '.8rem',
                                                fontFamily: 'Outfit,sans-serif',
                                                backgroundImage: `linear-gradient(317deg,#b58a1b 4.52%,#e0c060 34.37%,#ffeeb2 50.47%,#ffe77c 65.63%,#ffca41 110.56%)`,
                                                border: '2px solid #e0c060',
                                                borderRadius: '100px',
                                                boxShadow: '0 0 8px rgba(118, 118, 245, 0.8)',
                                                textTransform: 'uppercase',
                                                transition: 'all 0.3s ease-in-out',
                                                '&:hover': {
                                                    boxShadow: '0 0 16px rgba(118, 118, 245, 1)',
                                                    transform: 'scale(1.05)',
                                                },
                                            }}
                                            href='/'
                                        >
                                            Volver al inicio
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                            :

                            <Grid className='mt-bg-fondo' style={{
                                height: '980px',
                                backgroundColor: '#3f3d45',
                                margin: '0 auto',
                                position: 'relative',
                                backgroundPosition: '50%',
                                marginTop: props.isMobile ? '1%' : '2%'
                            }}>
                                <Grid className='container' style={{
                                    padding: props.isMobile ? 10 : 50,
                                    gap: '10px',
                                    justifyContent: 'center',
                                    overflow: 'scroll'


                                }}>
                                    <Grid style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 15 }}>


                                        <Box sx={{ mx: 'auto', my: 1, mt: '8%' }}>
                                            <Paper
                                                elevation={0}
                                                sx={{
                                                    maxWidth: !props.isMobile ? 650 : '100%',
                                                    margin: '0 auto',
                                                    borderRadius: success ? 'none' : '16px',
                                                    overflow: 'hidden',
                                                    backgroundColor: success ? 'transparent' : '#08142e',
                                                    color: '#fff',
                                                    p: props.isMobile ? 2 : 4,
                                                    border: '1px solid #1a3260',
                                                    boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
                                                }}
                                            >
                                                {
                                                    !success &&
                                                    <>
                                                        {/* Header 1xBet */}
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z" fill="#3b82f6" />
                                                                    <path d="M14 2V8H20L14 2Z" fill="#1d4ed8" />
                                                                    <path d="M16 12H8V14H16V12Z" fill="white" />
                                                                    <path d="M16 16H8V18H16V16Z" fill="white" />
                                                                    <path d="M11 8H8V10H11V8Z" fill="white" />
                                                                </svg>
                                                                <Typography sx={{ fontWeight: 'bold', fontSize: '1.25rem', fontFamily: 'Outfit, sans-serif' }}>
                                                                    Solicitud de tipeo
                                                                </Typography>
                                                            </Box>
                                                            <Button
                                                                variant="outlined"
                                                                size="small"
                                                                href="/guias"
                                                                startIcon={
                                                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                                        <circle cx="12" cy="12" r="10"></circle>
                                                                        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                                                                        <line x1="12" y1="17" x2="12.01" y2="17"></line>
                                                                    </svg>
                                                                }
                                                                sx={{
                                                                    color: '#94a3b8',
                                                                    borderColor: 'rgba(59, 130, 246, 0.2)',
                                                                    borderRadius: '999px',
                                                                    textTransform: 'none',
                                                                    fontSize: '0.75rem',
                                                                    py: 0.5,
                                                                    px: 1.5,
                                                                    backgroundColor: 'rgba(59, 130, 246, 0.06)',
                                                                    '&:hover': {
                                                                        borderColor: 'rgba(59, 130, 246, 0.4)',
                                                                        backgroundColor: 'rgba(59, 130, 246, 0.12)',
                                                                    }
                                                                }}
                                                            >
                                                                ¿Necesitas ayuda?
                                                            </Button>
                                                        </Box>

                                                        {/* Telegram Warning Cartel */}
                                                        {!isTelegramVerified && (
                                                            <Alert
                                                                severity="warning"
                                                                action={
                                                                    <Button color="inherit" size="small" onClick={() => setTelegramModalOpen(true)} sx={{ fontWeight: 700, textTransform: 'none', bgcolor: 'rgba(0,0,0,0.2)' }}>
                                                                        Verificar Ahora
                                                                    </Button>
                                                                }
                                                                sx={{
                                                                    mb: 3,
                                                                    borderRadius: '12px',
                                                                    fontFamily: 'Outfit, sans-serif',
                                                                    fontWeight: 700,
                                                                    fontSize: '0.9rem',
                                                                    color: '#FFF',
                                                                    backgroundColor: 'rgba(255, 170, 0, 0.2)',
                                                                    border: '1px solid rgba(255, 170, 0, 0.4)',
                                                                    backdropFilter: 'blur(10px)'
                                                                }}
                                                            >
                                                                Para reclamar el tipeo necesitas verificar tu cuenta en Telegram.
                                                            </Alert>
                                                        )}

                                                        {/* Progress Bar 1xBet */}
                                                        <Box sx={{ mb: 4 }}>
                                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                                                <Typography sx={{ fontSize: '0.9rem', color: '#cbd5e1', fontWeight: '500' }}>
                                                                    Paso <span style={{ color: '#3b82f6', fontWeight: 'bold' }}>{activeStep + 1}</span> de {steps.length}
                                                                </Typography>
                                                                <Typography sx={{ fontSize: '0.9rem', color: '#3b82f6', fontWeight: 'bold' }}>
                                                                    {Math.round(((activeStep + 1) / steps.length) * 100)}%
                                                                </Typography>
                                                            </Box>
                                                            <Box sx={{ width: '100%', height: '6px', backgroundColor: '#06102a', borderRadius: '999px', overflow: 'hidden', border: '1px solid #1a3260' }}>
                                                                <Box
                                                                    sx={{
                                                                        width: `${((activeStep + 1) / steps.length) * 100}%`,
                                                                        height: '100%',
                                                                        backgroundColor: '#3b82f6',
                                                                        borderRadius: '999px',
                                                                        transition: 'width 0.4s ease-in-out',
                                                                        boxShadow: '0 0 8px rgba(59, 130, 246, 0.7)',
                                                                    }}
                                                                />
                                                            </Box>
                                                        </Box>
                                                    </>
                                                }

                                                {success ? (
                                                    <Box
                                                        sx={{
                                                            backgroundColor: '#0c1b26',
                                                            borderRadius: '12px',
                                                            padding: 3,
                                                            width: '80%',
                                                            margin: '0 auto',
                                                            textAlign: 'center',
                                                            color: 'white',
                                                        }}
                                                    >
                                                        {/* Título con ícono y botón cerrar */}
                                                        <Box
                                                            sx={{
                                                                display: 'flex',
                                                                justifyContent: 'space-between',
                                                                alignItems: 'center',
                                                                mb: 2,
                                                            }}
                                                        >
                                                            <Typography sx={{ fontWeight: 'bold' }}>Solicitud de tipeo</Typography>
                                                            <Button sx={{ color: 'white' }} size="small" onClick={redirectHome}>✕</Button>
                                                        </Box>

                                                        {/* Imagen */}
                                                        <Box sx={{ mb: 2 }}>
                                                            <img
                                                                src={successImg}
                                                                alt="Caja fuerte"
                                                                style={{ width: '100%', height: 'auto', margin: '0 auto' }}
                                                            />
                                                        </Box>

                                                        {/* Mensaje principal */}
                                                        <Typography sx={{ fontSize: '1.2rem', fontWeight: 'bold', mb: 2 }}>
                                                            ¡Se completó tu solicitud de tipeo!
                                                        </Typography>

                                                        {/* Cuadro con correo */}
                                                        <Paper
                                                            elevation={0}
                                                            sx={{
                                                                backgroundColor: '#15232f',
                                                                color: 'white',
                                                                padding: 2,
                                                                borderRadius: '8px',
                                                                mb: 2,
                                                            }}
                                                            style={{ border: '2px dashed #2a2e38' }}
                                                        >
                                                            <Typography sx={{ fontSize: '0.9rem', textAlign: 'left' }}>
                                                                Cuando tu tipeo esté listo te llegará un correo a:
                                                            </Typography>
                                                            <Typography sx={{ fontWeight: 'bold', mt: 1, textAlign: 'left' }}>
                                                                {userEmail}
                                                            </Typography>
                                                        </Paper>

                                                        <Box style={{ display: 'flex', alignItems: 'center', gap: '5px', marginBottom: '15px' }}>
                                                            <Typography sx={{ fontSize: '0.9rem', textAlign: 'left' }}>
                                                                Dirección de retiro:
                                                            </Typography>
                                                            <Typography sx={{ fontWeight: 'bold', textAlign: 'left' }}>
                                                                {bnbAddress}
                                                            </Typography>
                                                        </Box>

                                                        <Alert
                                                            severity="warning"
                                                            sx={{
                                                                mb: 3,
                                                                textAlign: 'left',
                                                                backgroundColor: 'rgba(245, 158, 11, 0.1)',
                                                                color: '#fbbf24',
                                                                border: '1px dashed #f59e0b',
                                                                '& .MuiAlert-icon': { color: '#f59e0b' },
                                                                fontSize: '0.85rem'
                                                            }}
                                                        >
                                                            <strong>RECUERDA:</strong> Cuando te llegue el correo tienes 18 horas para verificar que hiciste el deposito acá en la página, o desde la aplicación en la sección TIPEOS. Evita entrar en la blacklist para poder seguir disfrutando de los beneficios!
                                                        </Alert>

                                                        {/* Botón */}
                                                        <Button
                                                            fullWidth
                                                            variant="contained"
                                                            sx={{
                                                                background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                                                borderRadius: '10px',
                                                                textTransform: 'none',
                                                                fontWeight: 'bold',
                                                                py: 1.2,
                                                                boxShadow: '0 4px 15px rgba(16, 185, 129, 0.35)',
                                                                '&:hover': {
                                                                    background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
                                                                },
                                                            }}
                                                            onClick={redirectHome}
                                                        >
                                                            Listo
                                                        </Button>
                                                    </Box>
                                                ) : (
                                                    <>
                                                        <XbetVerificationCard
                                                            username={nombre}
                                                            initialXbetId={xbetId}
                                                            onVerified={(id) => setXbetId(id)}
                                                        />
                                                        {error && (
                                                            <Alert severity="error" sx={{ mb: 2 }}>
                                                                {error}
                                                            </Alert>
                                                        )}
                                                        {getStepContent(activeStep)}
                                                        {isOpen && selectedImage && (
                                                            <div
                                                                style={{
                                                                    position: 'fixed',
                                                                    top: 0,
                                                                    left: 0,
                                                                    width: '100vw',
                                                                    height: '100vh',
                                                                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    zIndex: 99999,
                                                                }}
                                                            >
                                                                {/* Botón X para cerrar */}
                                                                <button
                                                                    onClick={closeImage}
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: 20,
                                                                        right: 20,
                                                                        background: 'transparent',
                                                                        border: 'none',
                                                                        fontSize: '32px',
                                                                        color: '#fff',
                                                                        cursor: 'pointer',
                                                                        zIndex: 99999,
                                                                    }}
                                                                    aria-label="Cerrar visor"
                                                                >
                                                                    &times;
                                                                </button>

                                                                {/* Imagen ampliada */}
                                                                <img
                                                                    src={selectedImage}
                                                                    alt="Expanded"
                                                                    style={{
                                                                        maxWidth: '90%',
                                                                        maxHeight: '90%',
                                                                        borderRadius: 10,
                                                                        boxShadow: '0 0 20px rgba(0,0,0,0.5)',
                                                                    }}
                                                                    onClick={(e) => e.stopPropagation()} // evita que se cierre al hacer click sobre la imagen
                                                                />
                                                            </div>
                                                        )}
                                                        {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 3 }}>
                                                {
                                                    activeStep !== 0 &&
                                                    <Button
                                                        disabled={activeStep === 0 || loading}
                                                        onClick={handleBack}
                                                        variant="outlined"
                                                    >
                                                        Atrás
                                                    </Button>
                                                }

                                                <Button
                                                    onClick={activeStep === steps.length - 1 ? handleRequestTipeo : handleNext}
                                                    variant="contained"
                                                    disabled={loading}
                                                >
                                                    {loading ? (
                                                        <CircularProgress size={24} />
                                                    ) : activeStep === steps.length - 1 ? (
                                                        'Terminar solicitud'
                                                    ) : (
                                                        'Siguiente'
                                                    )}
                                                </Button> 
                                            </Box> */}
                                                    </>
                                                )}
                                            </Paper>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                }

                <Dialog
                    open={showWarningModal}
                    onClose={() => setShowWarningModal(false)}
                    PaperProps={{
                        style: {
                            backgroundColor: '#0a1628',
                            color: 'white',
                            padding: '24px',
                            borderRadius: '16px',
                            textAlign: 'center',
                            maxWidth: '440px',
                            border: '1px solid #1e3a6e',
                            boxShadow: '0 12px 32px rgba(0,0,0,0.7)',
                        },
                    }}
                >
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
                        <Box
                            sx={{
                                width: '48px',
                                height: '48px',
                                borderRadius: '50%',
                                backgroundColor: 'rgba(239, 68, 68, 0.15)',
                                color: '#ef4444',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '1.6rem',
                                border: '1px solid rgba(239, 68, 68, 0.3)',
                            }}
                        >
                            ⚠️
                        </Box>

                        <Typography sx={{ fontWeight: 'bold', fontSize: '1.15rem', color: '#f8fafc' }}>
                            Requisito importante de la imagen
                        </Typography>

                        <Box
                            sx={{
                                backgroundColor: 'rgba(239, 68, 68, 0.08)',
                                border: '1px dashed rgba(239, 68, 68, 0.35)',
                                borderRadius: '10px',
                                p: 2,
                                textAlign: 'left',
                                width: '100%',
                                boxSizing: 'border-box',
                                my: 1,
                            }}
                        >
                            <Typography sx={{ fontSize: '0.9rem', color: '#cbd5e1', lineHeight: '1.6' }}>
                                • La captura debe ser <strong>tomada el día de hoy</strong>.<br />
                                • Debe enviarse <strong>completa, sin recortes ni modificaciones</strong>.<br /><br />
                                <span style={{ color: '#fca5a5' }}>
                                    De lo contrario, la solicitud <strong>será denegada automáticamente</strong>.
                                </span>
                            </Typography>
                        </Box>

                        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 1.5, width: '100%', mt: 1 }}>
                            <Button
                                variant="outlined"
                                onClick={() => setShowWarningModal(false)}
                                sx={{
                                    flex: 1,
                                    borderColor: '#334155',
                                    color: '#94a3b8',
                                    textTransform: 'none',
                                    fontWeight: 'bold',
                                    py: 1,
                                    '&:hover': { borderColor: '#64748b', color: '#f1f5f9', backgroundColor: 'rgba(255,255,255,0.05)' },
                                }}
                            >
                                Cancelar
                            </Button>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    setShowWarningModal(false);
                                    if (triggerUpload) triggerUpload();
                                }}
                                sx={{
                                    flex: 1.3,
                                    backgroundColor: '#22c55e',
                                    color: '#052e16',
                                    textTransform: 'none',
                                    fontWeight: 'bold',
                                    py: 1,
                                    boxShadow: '0 0 12px rgba(34, 197, 94, 0.4)',
                                    '&:hover': { backgroundColor: '#16a34a' },
                                }}
                            >
                                Aceptar y Cargar
                            </Button>
                        </Box>
                    </Box>
                </Dialog>

                <TelegramVerificationModal
                    open={telegramModalOpen}
                    onClose={() => setTelegramModalOpen(false)}
                    username={nombre}
                />
            </Grid>
        </Nlayout>
    )
}

export default Bonos



